module.exports = __webpack_public_path__ + "h5/img/baokuan.f5f5ea0b.png";